export function removeSpecialCharactersFromText(text: string): string {
  const nonAlphanumericRegex = /[^a-zA-Z0-9]/g;
  text = text.replace(nonAlphanumericRegex, '');

  return text;
}

export function capitialiseFirstLetter(str: string): string {
  if (!str || str.length === 0) {
    return str;
  }

  let processedStr = str;
  if (str === 'ONHOLD') {
    processedStr = str.replace(/\bONHOLD\b/g, 'On Hold');
  }

  processedStr = processedStr.replace(/_/g, ' ');

  const words = processedStr.split(' ');

  const processedWords = words.map((word) => {
    if (word.length === 0) {
      return '';
    }

    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return processedWords.join(' ');
}
